import styled, { css } from 'styled-components';
import { convertHex } from 'utils/color';

interface AmountBoxProps {
  bgColor: string;
}

const AmountBox = styled.div<AmountBoxProps>`
  background: ${({ theme: { color }, bgColor }) => color[bgColor]};
  text-align: center;
  border-radius: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  height: 88px;

  input {
    background: transparent;
    border: 0;
    font-weight: 500;
    font-size: 40px;
    line-height: 52px;
    outline: none;
    margin: 0 15px;
    text-align: right;
    position: relative;
    height: 100px;

    ${({ theme: { mui } }) => css`
      ${mui.breakpoints.down('xs')} {
        height: 100px;
      }
    `}
  }
`;

const AmountBoxTitle = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  position: absolute;
  right: 0px;
  left: 0px;
  margin-top: 5px;
`;

const CurrencySym = styled.span`
  color: ${({ theme: { color } }) => convertHex(color.gray_600, 0.6)};
  font-weight: 500;
  font-size: 40px;
  line-height: 52px;
`;

export { CurrencySym, AmountBox, AmountBoxTitle };
